/** @file bakedQuery: the baked-export query for the bake options (the Export popover and File > Export). */
import type { ExportQuery } from '@zilo/pose3d-api/types/restAdded';

/** The bake options the shell offers (the rest keep the server's defaults). */
export type BakeForm = { directions: string; scale: number; trim: boolean; grid: string };

/** The form as a baked ExportQuery; untouched fields are left out so the bake's defaults apply. */
export function bakedQuery(f: BakeForm): ExportQuery {
  return {
    format: 'baked',
    ...(f.directions === '' ? {} : { directions: Number(f.directions) }),
    ...(f.scale === 1 ? {} : { scale: f.scale }),
    ...(f.trim ? {} : { trim: false }),
    ...(f.grid === '' ? {} : { grid: f.grid === 'on' }),
  };
}
